// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LnU3","field":"styles_field__vfhAm","fieldCol":"styles_fieldCol__eKYzV","diffCol":"styles_diffCol__3p3Tj","diff":"styles_diff__1OkQG"};